import {
  PEOPLE_TEAM_ROUTES,
  SHARED_ROUTES,
  INTERNAL_TEAM_ROUTES,
} from "definitions/constants/routeConstants";
import { AiOutlineIssuesClose } from "react-icons/ai";
import { FiSettings, FiList, FiUsers, FiGrid } from "react-icons/fi";
import { GiTrail } from "react-icons/gi";
import { TbMap2 } from "react-icons/tb";
import { MdOutlineAnalytics } from "react-icons/md";
import CalendarMonth from "components/Icon/Iconify/CalendarMonth";
import {
  baseDashboard, baseMyJourneys, baseTasks, companyIntegrations, SidebarSection,
} from "./shared";

const peopleTeamDashboard = {
  id: "people-team-dashboard",
  name: "People Team Dashboard",
  route: PEOPLE_TEAM_ROUTES.dashboard,
  icon: MdOutlineAnalytics,
  routeMatchExact: true,
};

const peopleTeamIssues = {
  id: "issues",
  name: "Issues",
  route: PEOPLE_TEAM_ROUTES.issues.base,
  icon: AiOutlineIssuesClose,
};

const peopleAndJourneys = {
  id: "new-hire-journeys",
  name: "Journeys",
  route: INTERNAL_TEAM_ROUTES.newHireJourneys.index,
  icon: TbMap2,
  additionalRoutes: [
    { path: INTERNAL_TEAM_ROUTES.newHireJourneys.pending.index, exactMatch: false },
    { path: INTERNAL_TEAM_ROUTES.newHireJourneys.pending.show, exactMatch: false },
  ],
};

const peopleTeamPaths = {
  id: "paths",
  name: "Planning & Paths",
  route: PEOPLE_TEAM_ROUTES.planning.index,
  icon: GiTrail,
  // Keep highlighted on path detail pages, which still live under /paths/:id.
  additionalRoutes: [{ path: SHARED_ROUTES.paths.index, exactMatch: false }],
};

const meetingSchedule = {
  id: "schedule",
  name: "Meetings",
  route: SHARED_ROUTES.meetingEvents.index,
  icon: CalendarMonth,
};

const activityFeed = {
  id: "activity-feed",
  name: "Activity Feed",
  route: PEOPLE_TEAM_ROUTES.activityFeed.index,
  icon: FiList,
};

const taskGrid = {
  id: "task-grid",
  name: "Task Grid",
  route: PEOPLE_TEAM_ROUTES.taskGrid,
  icon: FiGrid,
};

const workforce = {
  id: "workforce",
  name: "Workforce",
  route: PEOPLE_TEAM_ROUTES.workforce,
  icon: FiUsers,
};

const companySettings = {
  id: "company-settings",
  name: "Settings",
  route: PEOPLE_TEAM_ROUTES.company.settings,
  icon: FiSettings,
};

const peopleTeamSidebarItems: SidebarSection[] = [
  {
    id: "top",
    items: [baseDashboard, baseTasks, baseMyJourneys],
  },
  {
    id: "onboarding",
    header: "Onboarding",
    items: [peopleTeamDashboard, taskGrid, peopleAndJourneys, peopleTeamIssues, peopleTeamPaths, meetingSchedule, activityFeed],
  },
  {
    id: "company",
    header: "Company",
    items: [workforce, companySettings, companyIntegrations],
  },
];

export default peopleTeamSidebarItems;
